var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('barcode-time-clock-handler',{staticClass:"mt-2",attrs:{"used-in-touch-interface":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }